import { render } from "./IconTextBoxMultiple.vue?vue&type=template&id=0d46b960"
import script from "./IconTextBoxMultiple.vue?vue&type=script&lang=js"
export * from "./IconTextBoxMultiple.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icons/IconTextBoxMultiple.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0d46b960"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0d46b960', __exports__)) {
    api.reload('0d46b960', __exports__)
  }
  
  module.hot.accept("./IconTextBoxMultiple.vue?vue&type=template&id=0d46b960", () => {
    api.rerender('0d46b960', render)
  })

}


export default __exports__